import * as React from 'react';
import type { SVGProps } from 'react';

const SvgChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={10} height={6} fill="none" {...props}>
    <path
      fill="#000"
      d="M9.78.441A.767.767 0 0 0 9.248.23c-.199 0-.39.076-.531.211L4.995 4.024 1.275.44a.768.768 0 0 0-.53-.203A.767.767 0 0 0 .22.45.71.71 0 0 0 0 .956a.71.71 0 0 0 .211.509l4.253 4.094a.767.767 0 0 0 .531.211c.2 0 .391-.076.532-.211L9.78 1.465A.71.71 0 0 0 10 .953a.71.71 0 0 0-.22-.512Z"
    />
  </svg>
);
export default SvgChevronDownIcon;
